// extracted by mini-css-extract-plugin
export default {"row":"deviceListDowntime_row__zwNzj","label":"deviceListDowntime_label__cTfyq","text":"deviceListDowntime_text__WxQag","split":"deviceListDowntime_split__dCTO6"};